import React, { createContext, useState } from "react";

export const tableDataContext = createContext();

export const TableDataProvider = ({ children }) => {
  const [pdfData, setPdfData] = useState(null);
  const [responseDatapdf, setResponseDatapdf] = useState([]);
  const [allResponse, setAllResponse] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [adminFiltered, setAdminFiltered] = useState([]);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [filters, setFilters] = useState([]);
  const [vendorNames, setvendorNames] = useState([]);
  const [filterVendorData, setFilterVendorData] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState();

  return (
    <tableDataContext.Provider
      value={{
        pdfData,
        setPdfData,
        responseDatapdf,
        setResponseDatapdf,
        setAllResponse,
        allResponse,
        fullData,
        setFullData,
        adminFiltered,
        setAdminFiltered,
        selectedFilters,
        setSelectedFilters,
        filters,
        setFilters,
        vendorNames,
        setvendorNames,
        setFilterVendorData,
        filterVendorData,
        selectedVendor,
        setSelectedVendor,
      }}
    >
      {children}
    </tableDataContext.Provider>
  );
};
